/**
 * Sabal Swim — Notify Me / Back-in-Stock guard
 *
 * The "Back in Stock" app (SealApps, assets/product_restore_email.js) decides
 * whether to show a "NOTIFY ME WHEN BACK IN STOCK" button by calling its own
 * external API (emailnoticeapi.sealapps.com) rather than Shopify's live
 * inventory. When that app's data is out of sync, it can show the notify
 * button on a product/variant that is actually in stock.
 *
 * This script is a lightweight, fail-safe guard: any time a
 * ".product-restore-email" widget appears on the page, it double-checks the
 * relevant product/variant against Shopify's own live data
 * (/products/<handle>.js). If Shopify says the item is actually available,
 * it hides the notify widget and makes sure the real Add to Cart control is
 * visible again. If the check fails or is inconclusive for any reason, it
 * does nothing and leaves the existing behavior untouched.
 */
(function () {
  "use strict";

  if (window.__sabalStockGuardInit) return;
  window.__sabalStockGuardInit = true;

  var productCache = {};

  function fetchProductJSON(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch("/products/" + handle + ".js", {
        credentials: "same-origin",
      })
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .catch(function () {
          return null;
        });
    }
    return productCache[handle];
  }

  function resolveHandle(widget) {
    var card = widget.closest(
      ".product-card, .pair-with-card, [data-product-handle], [data-product-url]"
    );
    if (card) {
      var explicitHandle = card.getAttribute && card.getAttribute("data-product-handle");
      if (explicitHandle) return explicitHandle;

      var explicitUrl = card.getAttribute && card.getAttribute("data-product-url");
      var link = explicitUrl ? null : card.querySelector('a[href*="/products/"]');
      var href = explicitUrl || (link && link.getAttribute("href"));
      if (href) {
        var m = href.match(/\/products\/([^/?#]+)/);
        if (m) return decodeURIComponent(m[1]);
      }
    }
    var pathMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return pathMatch ? decodeURIComponent(pathMatch[1]) : null;
  }

  function resolveVariantId(widget) {
    var form = widget.closest("form");
    if (!form) return null;
    var field = form.querySelector('input[name="id"], select[name="id"]');
    return field && field.value ? String(field.value) : null;
  }

  function unhideAddToCart(widget) {
    var scope = widget.closest("form") || widget.parentElement;
    if (!scope) return;
    var candidates = scope.querySelectorAll(
      'button[type="submit"], .add-to-cart-btn, .add-to-cart-form, .quantity-submit-row'
    );
    candidates.forEach(function (el) {
      if (el === widget || widget.contains(el)) return;
      var style = el.getAttribute("style") || "";
      if (/display\s*:\s*none/i.test(style)) {
        el.style.removeProperty("display");
      }
      if ("disabled" in el) el.disabled = false;
    });
  }

  function reconcile(widget) {
    if (!widget || widget.getAttribute("data-sabal-stock-checked")) return;
    widget.setAttribute("data-sabal-stock-checked", "true");

    var handle = resolveHandle(widget);
    if (!handle) return;
    var variantId = resolveVariantId(widget);

    fetchProductJSON(handle).then(function (product) {
      if (!product) return;

      var isAvailable = product.available;
      if (variantId && product.variants) {
        for (var i = 0; i < product.variants.length; i++) {
          if (String(product.variants[i].id) === variantId) {
            isAvailable = !!product.variants[i].available;
            break;
          }
        }
      }

      if (isAvailable) {
        widget.style.setProperty("display", "none", "important");
        unhideAddToCart(widget);
      }
    });
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(".product-restore-email").forEach(reconcile);
  }

  function init() {
    scan(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(".product-restore-email")) {
            reconcile(node);
          }
          scan(node);
        });
      });
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    [1000, 3000, 6000].forEach(function (delay) {
      setTimeout(function () {
        scan(document);
      }, delay);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
